import React from "react";
import { Divider, Skeleton, Stack } from "@mui/material";

const MyOrderAddressSkeleton = () => {
  return (
    <Stack spacing={2} className="delivery-address">
      <div className="title">Delivery Address</div>
      <div className="user-delivery-details">
        <div className="name-and-contact">
          <div className="name">
            <Skeleton animation="wave" width="100px" />
          </div>
          <Divider orientation="vertical" flexItem />
          <div className="contact-no">
            <Skeleton animation="wave" width="100px" />
          </div>
        </div>
        <div className="user-delivery-address">
          <Skeleton animation="wave" width="100%" />
        </div>
      </div>
    </Stack>
  );
};

export default MyOrderAddressSkeleton;
